import React from "react";
import styled from "styled-components";
import TopNavbar from "../components/Nav/TopNavbar";
import Footer from "../components/Sections/Footer";

export default function AccessibilityPage({ navigate }) {
  return (
    <>
      <TopNavbar navigate={navigate} currentPage="" />
      <PageHero className="pageHero">
        <div className="container">
          <h1 className="font40 extraBold darkColor heroTitle">הצהרת נגישות ♿</h1>
          <p className="font15 darkColor" style={{ marginTop: "10px", opacity: 0.8 }}>
            עודכן לאחרונה: 23.10.2026
          </p>
        </div>
      </PageHero>

      <PageBody>
        <div className="container">
          <Section>
            <h2 className="font25 extraBold darkColor">1. מחויבות לנגישות</h2>
            <BodyText>
              הלב הצבעוני מאמין שכל אדם זכאי לגישה שווה למידע ולשירות, ללא קשר ליכולות
              ומוגבלויות. אנו פועלים להנגשת האתר בהתאם ל<strong>תקן ישראלי 5568</strong> (המבוסס על
              {" "}<strong>WCAG 2.1 רמה AA</strong>) ובהתאם ל<strong>תקנות שוויון זכויות לאנשים עם מוגבלות
              (התאמות נגישות לשירות), תשע"ג–2013</strong>.
            </BodyText>
          </Section>

          <Divider />

          <Section>
            <h2 className="font25 extraBold darkColor">2. מה עשינו להנגשה</h2>
            <BodyText>בין הפעולות שביצענו להנגשת האתר:</BodyText>
            <List>
              <li>האתר מוצג בכיוון קריאה מימין לשמאל (RTL) בהתאם לשפה העברית.</li>
              <li>שימוש בהיררכיית כותרות תקינה (H1, H2, H3) לניווט קל.</li>
              <li>ניגודיות צבעים עומדת בדרישות רמה AA.</li>
              <li>טקסט חלופי (alt) לתמונות משמעותיות.</li>
              <li>כפתורים ולינקים עם תיאור נגיש.</li>
              <li>האתר תומך בהגדלת טקסט דרך הדפדפן עד 200%.</li>
              <li>כלי נגישות מובנה המאפשר שינוי גודל טקסט וניגודיות.</li>
            </List>
          </Section>

          <Divider />

          <Section>
            <h2 className="font25 extraBold darkColor">3. מגבלות ידועות</h2>
            <BodyText>
              אנו ממשיכים לשפר את נגישות האתר. ייתכן שחלק מהתכנים טרם הונגשו
              במלואם, לרבות:
            </BodyText>
            <List>
              <li>חלק מהתמונות הדקורטיביות עשויות לחסור תיאור חלופי.</li>
              <li>תכנים מוטמעים מצד שלישי (כגון טפסים חיצוניים) עשויים שלא לעמוד
                בכל דרישות הנגישות.</li>
            </List>
          </Section>

          <Divider />

          <Section>
            <h2 className="font25 extraBold darkColor">4. כלי הנגישות באתר</h2>
            <BodyText>
              בצד האתר (למטה משמאל) תמצאי כפתור נגישות <strong>♿</strong> המאפשר:
            </BodyText>
            <List>
              <li>הגדלה והקטנה של גודל הטקסט.</li>
              <li>מעבר למצב ניגודיות גבוהה.</li>
              <li>הדגשת קישורים.</li>
            </List>
          </Section>

          <Divider />

          <Section>
            <h2 className="font25 extraBold darkColor">5. פניות בנושא נגישות</h2>
            <BodyText>
              נתקלת בבעיית נגישות? נשמח לדעת כדי לשפר. ניתן לפנות אלינו:
            </BodyText>
            <ContactBox className="lightBg radius8">
              <ContactRow>
                <strong>רכזת נגישות:</strong>
                {/* TEXT PLACEHOLDER */}
                <span> שם מלא</span>
              </ContactRow>
              <ContactRow>
                <strong>אימייל:</strong>
                {/* TEXT PLACEHOLDER */}
                <span> carmela0208@gmail.com</span>
              </ContactRow>
              <ContactRow>
                <strong>טלפון:</strong>
                {/* TEXT PLACEHOLDER */}
                <span> 050-000-0000</span>
              </ContactRow>
              <ContactRow>
                <strong>אנו מתחייבים לחזור אלייך תוך:</strong>
                <span> 5 ימי עסקים</span>
              </ContactRow>
            </ContactBox>
          </Section>

          <Divider />

          <Section>
            <h2 className="font25 extraBold darkColor">6. אמצעי נגישות נוספים</h2>
            <BodyText>
              אם את משתמשת בטכנולוגיה מסייעת (קורא מסך, תוכנת הגדלה וכד') ונתקלת
              בבעיה, פני אלינו ונסייע לך לקבל את המידע בפורמט מונגש.
            </BodyText>
          </Section>

          <BackBtn onClick={() => navigate("home")} className="pinkBg whiteColor radius8 pointer semiBold font15">
            חזרה לדף הבית
          </BackBtn>
        </div>
      </PageBody>

      <Footer navigate={navigate} />
    </>
  );
}

const PageHero = styled.section`
  padding: 120px 0 40px;
  direction: rtl;
`;
const PageBody = styled.div`
  padding: 60px 0 80px;
  direction: rtl;
`;
const Section = styled.div`
  margin-bottom: 10px;
`;
const BodyText = styled.p`
  margin-top: 12px;
  line-height: 1.9;
  color: var(--ink-soft);
  font-size: 0.938rem;
`;
const List = styled.ul`
  list-style: disc;
  padding-right: 24px;
  margin-top: 12px;
  li {
    margin-bottom: 8px;
    line-height: 1.8;
    color: var(--ink-soft);
    font-size: 0.938rem;
  }
`;
const Divider = styled.hr`
  border: none;
  border-top: 1px solid var(--rose-200);
  margin: 30px 0;
`;
const ContactBox = styled.div`
  margin-top: 16px;
  padding: 24px 28px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const ContactRow = styled.p`
  font-size: 0.938rem;
  color: var(--ink-soft);
  line-height: 1.6;
`;
const BackBtn = styled.button`
  margin-top: 40px;
  padding: 14px 30px;
  font-size: 1rem;
  border: none;
  cursor: pointer;
`;
